export const version = "5.16.7";
export const major = Number("5");
export const minor = Number("16");
export const patch = Number("7");
export const preReleaseLabel = undefined || null;
export const preReleaseNumber = Number(undefined) || null;
export default version;